import { createReducer, createNamespacer } from '../../commons/js/utils/reducer';
import { fromPairs as _fromPairs } from 'lodash';

const bolEmail = createNamespacer("BOL_EMAIL")

const initialState = {
    bolEmail: {
        to: {
            value: "",
            error: "",
            showError: "",
        },
        cc: {
            value: "",
            error: "",
            showError: "",
        },
        bolPdf: "",
        content: {
            value: "",
            error: "",
            showError: "",
        },
        subject: {
            value: "",
            error: "",
            showError: "",
        },
    }
}

export const bolEmailReducer = createReducer(initialState.bolEmail, {
    [bolEmail("SET_TO")]: (state, action) => {
        return {
            ...state,
            to: {
                ...state.to,
                value: action.payload.value,
            }
        }
    },
    [bolEmail("SET_CC")]: (state, action) => {
        return {
            ...state,
            cc: {
                ...state.cc,
                value: action.payload.value,
            }
        }
    },
    [bolEmail("SET_BOL_PDF")]: (state, action) => {
        return {
            ...state,
            bolPdf: action.payload.value,
        }
    },
    [bolEmail("SET_SUBJECT")]: (state, action) => {
        return {
            ...state,
            subject: {
                ...state.subject,
                value: action.payload.value,
            }
        }
    },
    [bolEmail("SET_CONTENT")]: (state, action) => {
        return {
            ...state,
            content: {
                ...state.content,
                value: action.payload.value,
            }
        }
    },
    [bolEmail("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },
    [bolEmail("CLEAR_FORM")]: (state, action) => {
        return {
            ...initialState.bolEmail,
        }
    },
});

